import palette from '@lib/core/src/theme/palette';
import { Stack, styled, Typography } from '@mui/material';

export const Container = styled(Stack)({
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  maxWidth: '480px',
  padding: '0px 40px 32px 40px'
});

export const TitlesContainer = styled(Stack)({
  gap: '9px',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%'
});

export const TitleDescription = styled(Typography)({
  color: palette.typography.grey,

  fontSize: '16px',
  fontWeight: 500
});

export const Title = styled(Typography)({
  color: palette.typography.black,
  fontSize: '28px',
  fontWeight: 600
});

export const InputsContainer = styled(Stack)({
  marginTop: '40px',
  minHeight: '132px',
  gap: '16px',
  width: '100%'
});

export const InputAndTitleContainer = styled(Stack)({
  gap: '6px'
});

export const InputTitle = styled(Typography)({
  color: palette.typography.grey,

  fontSize: '11px',
  fontWeight: 500
});

export const InputContainer = styled(Stack)({
  alignItems: 'center',
  flexWrap: 'nowrap',
  gap: '8px',
  position: 'relative',
  padding: '12px 10px',
  background: 'white',
  overflow: 'hidden',
  borderRadius: '8px',
  border: `1px solid ${palette.border.grey}`
});

export const Input = styled('input')({
  height: '14px',
  background: 'transparent',
  border: 'none',
  outline: 'none',
  fontSize: '12px',
  fontWeight: 400
});

export const InputError = styled(Typography)({
  color: 'red',
  marginTop: '2px',
  fontSize: '12px',
  marginLeft: '10px'
});

export const ForgotPassword = styled(Typography)({
  color: palette.typography.black,
  fontSize: '12px',
  fontWeight: 500
});

export const ClickHere = styled(Typography)({
  color: palette.button.text.blue,
  fontSize: '12px',
  fontWeight: 500,
  cursor: 'pointer',
  ':hover': {
    textDecoration: 'underline',
    opacity: 0.8
  }
});

export const LoginButton = styled('button')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexWrap: 'nowrap',
  gap: '4px',
  position: 'relative',
  width: '200px',
  margin: '36px 0 0 0',
  padding: '12px 12px 12px 12px',
  cursor: 'pointer',
  background: 'rgba(255, 255, 255, 0.08000000000000002)',
  border: 'none',
  overflow: 'hidden',
  borderRadius: '6px'
});

export const LoginButtonText = styled(Typography)({
  color: '#f8f8f8',
  fontSize: '13px',
  fontWeight: 600
});
